import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ElectionService {
  constructor(private http: HttpClient) {}

  public getElections() {
    return this.http.get<any>("/edozzier/election/get-elections.php");
  }
  public getElectionOffices(data) {
    return this.http.post<any>(
      "/edozzier/election/get-election-offices.php",
      data
    );
  }
  public vote(data) {
    return this.http.post<any>("/edozzier/election/vote.php", data);
  }
}
